
export default {
    props: {
        afterSalesOrdersData: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {
            orderFlow: [
                {
                    stateName: "交易结束",
                    createTime: "2025-06-27 10:34:11",
                },
                {
                    stateName: "财务放款",
                    createTime: "2025-06-27 10:34:11",
                },
                {
                    stateName: "帐号换绑",
                    createTime: "2025-06-27 10:34:11",
                }
            ],
            orderImGoods: {
                goodsImg: 'https://oss.pzds.com/mobileV3/202507241559705.png',
                orderNo: '123123123',
                createTime: '2021-01-01 12:00:00',
                gameIdName: '游戏名称',
                orderTypeName: '订单类型',
                compensationName: '包赔类型',
                statusName: '订单状态',
            }
        }
    },
    computed: {
        remainingTimeText() {
            if(this.afterSalesOrdersData.status === 3){
                return '问题已处理完成';
            }
            if (!this.afterSalesOrdersData.estimatedCompletionTime) {
                return '老板稍等，客服正在处理中';
            }

            const now = new Date();
            const completionTime = new Date(this.afterSalesOrdersData.estimatedCompletionTime);

            // 计算时间差（毫秒）
            const timeDiff = completionTime.getTime() - now.getTime();

            if (timeDiff <= 0) {
                return '客服正在加急处理中';
            }

            // 转换为天、小时、分钟
            const days = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
            const hours = Math.floor((timeDiff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            const minutes = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60));
            let timeText = '老板稍等，客服将在';
            if (days > 0) {
                timeText += `<span style="color: #FA9600">${days}</span>天`;
            }
            if (hours > 0) {
                timeText += `<span style="color: #FA9600">${hours}</span>小时`;
            }
            if (minutes > 0) {
                timeText += `<span style="color: #FA9600">${minutes}</span>分`;
            }

            timeText += '内处理完成';

            return timeText;
        }
    },
    methods: {

    }
}
